import common from './ja/common';
import home from './ja/home';
import airports from './ja/airports';
import profiles from './ja/profiles';
import settings from './ja/settings';
import reviews from './ja/reviews';
import inventory from './ja/inventory';
import auth from './ja/auth';
import navigation from './ja/navigation';

// Merge all translation categories into one object
const translations = {
  ...common,
  ...home,
  ...airports,
  ...profiles,
  ...settings,
  ...reviews,
  ...inventory,
  ...auth,
  ...navigation,
};

export default translations;
